import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import Create_link from './create_link';
import History_buylink from './history_buylink';
import History_create from './history_create';
import History_home from './history';
import Pay from './pay';
import Api from './api';
import Guide from './guide';
import Post_content from '../../../community/content/Blog_posts.jsx';
const LazyReCAPTCHA = lazy(() => import("../../../app_structure/LazyReCAPTCHA.jsx"));
const LivestreamViewer = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const [nutxuly, setnutxuly] = useState(0);
    const [showcaptcha, setshowcaptcha] = useState(false);
    const [nutorder, setnutorder] = useState('Thanks =D');
    const [comments, setComments] = useState([]);
    const [inputComment, setInputComment] = useState('');
    const audioRef = useRef(null);

    const { slug_2 } = useParams();
    useEffect(() => {
        // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
        laydulieu();
    }, []);
    const laydulieu = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey !== null) {
            // Có API key, thực hiện các hành động cần thiết
            laythongtin(apiKey);
        } else {
            // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
            console.log('Không có API key.');
        }
    };
    const laythongtin = (apikey) => {
        axios
            .get('https://hust.media/link/load_users/get_info.php', {
                params: {
                    apikey: apikey,
                    service: 'start'
                }
            })
            .then(response =>
                testFunction(response)
            )
            .catch(error => console.log(123 + error));
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        setnutxuly(0);
        // if (status == 0) {
        //   alert_error(info.message);
        // }
        // else if (status == 1) {
        //   alert_success(info.message);
        // }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    return (
        <>
            <div className="flex flex-col items-center">
                {/* Nút để di chuyển đến mốc thời gian sớm nhất */}
                <div className="flex mt-2 space-x-4">
                    <div className="border-2 px-2 py-1 rounded-md">
                        <button
                            className={`border-b-4 text-lg ${slug_2 === 'home' ? 'border-black' : 'border-transparent'}`}
                            onClick={() => switch_router('/shop/creative/home')}
                        >
                            home
                        </button>
                    </div>
                    <div className="border-2 px-2 py-1 rounded-md">
                        <button
                            className={`border-b-4 text-lg ${slug_2 === 'create' ? 'border-black' : 'border-transparent'}`}
                            onClick={() => switch_router('/shop/creative/create')}
                        >
                            create
                        </button>
                    </div>
                    <div className="border-2 px-2 py-1 rounded-md">
                        <button
                            className={`border-b-4 text-lg ${slug_2.includes('history') ? 'border-black' : 'border-transparent'}`}
                            onClick={() => switch_router('/shop/creative/history?app=showadview')}
                        >
                            history
                        </button>
                    </div>
                    <div className="border-2 px-2 py-1 rounded-md">
                        <button
                            className={`border-b-4 text-lg ${slug_2 === 'pay' ? 'border-black' : 'border-transparent'}`}
                            onClick={() => switch_router('/shop/creative/pay?app=showadview')}
                        >
                            Pay
                        </button>
                    </div>
                </div>
            </div>
            {
                slug_2 === 'home' ? (<>                                 <Helmet>
                    <title>Link sáng tạo</title>
                </Helmet>
                    <div className="row fixrow">
                        {/* <div className="max-h-32">
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="8795043992"
                        style={{ display: "block", height: 100 }}
                        format=""
                    />{" "}
                </div>   </div> */}
                        <Helmet>
                            <title>Link sáng tạo</title>
                        </Helmet>
                        <div className="mt-2 flex flex-wrap ">
                            <div className="w-1/2  sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/create" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Tạo link sáng tạo
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (Kiếm Coins với content của bạn)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/history_create?app=showadview" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Lịch sử link sáng tạo
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (Xem lịch sử tạo link Hust Media)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/history_buylink?app=showadview" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Lịch sử mua link
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (Xem lịch sử mua link Hust Media)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/api?app=showadview" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Api link sáng tạo
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (Chuyên nghiệp hóa với api)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/pay?app=showadview" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Rút Coins sáng tạo
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (Chuyển số dư sáng tạo qua số dư chính)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1">
                                <Link to="/shop/creative/guide?app=showadview" className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-lg text-slate-1000">
                                                        Hướng dẫn sử dụng
                                                    </div>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        (✨ Hướng dẫn kiếm Coins từ links sáng tạo! ✨)
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-1"></div>
                            <div class="sm:w-full md:w-1/2 lg:w-1/2  xl:w-1/3  p-1">
                                <div className="no-underline">
                                    <div className="max-w-7xl mx-2 py-0 mb-0">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <div className="text-base block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        <img
                                                            src="https://tecom.pro/img/icon/200w.gif"
                                                            className="h-6 w-6 cananh"
                                                            alt="icon"
                                                        /> Quy định
                                                    </div>
                                                    <div className="flex items-center justify-center text-center text-lg text-slate-1000">
                                                        <div className="">
                                                            <Post_content mode={'telegram'} show_adsense={'NO'} channel={'freefltiktok'} id_post={'281'} />
                                                        </div>
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <br /> <br />
                </>) :
                    slug_2 === 'create' ? (<> <Create_link /></>)
                        : slug_2 === 'history_buylink' ? (<><History_buylink /></>)
                            : slug_2 === 'history_create' ? (<><History_create /></>)
                                : slug_2 === 'history' ? (<><History_home /></>)
                                    : slug_2 === 'pay' ? (<><Pay /></>)
                                        : slug_2 === 'api' ? (<><Api /></>)
                                            : slug_2 === 'guide' ? (<>  <Guide /></>)
                                                : (<></>)
            }
        </>
    );
};

export default LivestreamViewer;
